const isNewGoogleUser = (loggedInUser) => {
  const isNewUser = loggedInUser.metadata.creationTime === loggedInUser.metadata.lastSignInTime
  const isGoogleUser = loggedInUser.providerData[0].providerId === 'google.com'

  return isNewUser && isGoogleUser
}

export default isNewGoogleUser
